import React from 'react';
import { LPA_LOGO_B64 } from '../badges';
import { ensureUs, pageKeys, txt, partLabel } from './model';
import { PAGES } from './pages';

// Renders a US datasheet (fixture / housing / fitting + housing) from sheet.us.
export default function USDatasheet({ sheet, pageId }) {
  const us = ensureUs(sheet);
  const keys = pageKeys(us);
  const logos = { primary: 'data:image/png;base64,' + LPA_LOGO_B64, secondary: us.logos.secondary || '', tertiary: us.logos.tertiary || '' };
  return (
    <div className="ds-document usds-doc" data-testid="us-datasheet" data-variant={us.variant} data-mode={us.mode} id={pageId}>
      {keys.map((key) => {
        const Cmp = PAGES[key];
        const isHousing = key.startsWith('housing');
        const sheetKeys = keys.filter(k => k.startsWith(isHousing ? 'housing' : 'fixture'));
        const footerLabel = isHousing ? txt(us.housing.name) : txt(us.meta.productName);
        return <Cmp key={key} data={isHousing ? us.housing : us.fixture} meta={us.meta} mode={us.mode} logos={logos} options={us.options} page={sheetKeys.indexOf(key) + 1} total={sheetKeys.length} footerLabel={footerLabel} part={partLabel(us.variant)} />;
      })}
    </div>
  );
}
